import React from 'react';
import { PageWrapper } from '@monorepo/page-builder';
import Layout from '@monorepo/layout/components/Layout';
import pages from './pages';
import componentsMap from './componentsMap';
import { useIsAuthenticated } from '@monorepo/auth';
import Loader from '../Loader';

const Page = () => {
  const { isFetched, data } = useIsAuthenticated();

  return (
    <PageWrapper
      pages={pages}
      componentsMap={componentsMap}
      unAuthorizedRoute={'/login'}
      homePageRoute={'/orders'}
      page404Route={'/404'}
      pageFormFactor={'desktop'}
      isAuthFetched={isFetched}
      isAuthenticated={Boolean(data?.userId)}
      LayoutComponent={Layout}
      LoaderComponent={Loader}
    />
  );
};

export default Page;
